import { Dialog, Transition } from '@headlessui/react';
import React, { useEffect, useState, useRef } from 'react';
import { Fragment } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IconAdjustmentsHorizontal, IconX, IconTrash, IconXboxX } from '@tabler/icons-react';
import LoadingIndicator from '../LoadingIndicator';

export default function HapusBanyakBarang({
  setOpenHapusBanyakBarang,
  refreshPage,
  reloadDate,
  openHapusBarangBanyak,
  cabang,
  setSelectedItems,
  selectedItems,
  resetSelectPindahItems,
  closeModalBanyakBarang,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const ids = selectedItems.map((item) => item.id);
  const [selectCabang, setSelectCabang] = useState([]);
  const [idCabang, setIdCabang] = useState(0);
  const [keterangan, setKeterangan] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const keteranganRef = useRef(null);

  useEffect(() => {
    if (!openHapusBarangBanyak) {
      setShowConfirm(false);
      setKeterangan('');
    }
  }, [openHapusBarangBanyak]);


  // useEffect(() => {
  //   async function getCabangSelect() {
  //     await http
  //       .get(`cabang/brankas`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setSelectCabang(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getCabangSelect();
  // }, [navigate]);

  // const [cabangId, setCabangId] = useState(0);

  async function handleSubmitHapusBanyakBarang(e) {
    e.preventDefault();
    setLoading(true);
    const formData = {
      items: ids,
      keterangan: keterangan,
    };
    // if (cabangId !== 0) {
    try {
      const response = await http.post('/item/hapus-multi', formData, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      // console.log(response.data)
      toast.success('Data berhasil dihapus', { autoClose: 600, });
      setOpenHapusBanyakBarang(false);
      setIsOpenModalConfirm(false);
      reloadDate();
      setLoading(false);
      resetSelectPindahItems();
      return response.data
    } catch (error) {
      console.log(error);
    }
    // } else {
    //   toast.error('Pilih toko dulu', { autoClose: 600, });
    // }
    setLoading(false);
  }

  // async function handleSubmitPindahBarang(e) {
  //   e.preventDefault();
  //   setLoading(true);
  //   const formData = {
  //     cabang_id: idCabang,
  //     items: ids,
  //   };
  //   // if (idCabang !== 0) {
  //   try {
  //     const response = await http.post('/item/transfer', formData, {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     // console.log(response.data)
  //     toast.success('Data berhasil dihapus', { autoClose: 600, });
  //     setOpenHapusBanyakBarang(false);
  //     refreshPage();
  //     setLoading(false);
  //     return response.data
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   // } else {
  //   //   toast.error('Pilih cabang tujuan', { autoClose: 600, });
  //   // }
  //   setLoading(false);
  // }

  function fake() { }
  function removeSelectedItem(itemId) {
    setSelectedItems(currentItems => currentItems.filter(item => item.id !== itemId));
  }
  return (
    <>
      {loading &&
        <LoadingIndicator />
      }
      <Transition appear show={openHapusBarangBanyak} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={fake}
          initialFocus={!showConfirm ? keteranganRef : undefined}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-screen">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`w-full ${showConfirm ? 'max-w-md' : 'max-w-2xl'} transform overflow-hidden bg-white dark:bg-slate-900 sm:rounded-xl p-0 text-left align-middle shadow-xl transition-all flex flex-col max-h-[90vh] border dark:border-slate-800`}>

                  {!showConfirm ? (
                    /* Step 1: List Review */
                    <>
                      {/* Header */}
                      <div className="px-5 py-3 border-b border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-900 flex items-center justify-between sticky top-0 z-10 w-full">
                        <div>
                          <Dialog.Title as="h2" className="text-lg sm:text-xl font-bold text-slate-800 dark:text-slate-100">
                            Hapus Banyak Barang
                          </Dialog.Title>
                          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Akan menghapus {ids?.length} barang sekaligus</p>
                        </div>
                        <button
                          onClick={closeModalBanyakBarang}
                          className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 dark:hover:text-slate-300 transition-colors"
                        >
                          <IconX className="w-5 h-5" />
                        </button>
                      </div>

                      {/* Body / Scrollable Content */}
                      <div className="p-5 overflow-y-auto flex-1 bg-slate-50/50 dark:bg-slate-900/50">
                        <div className="bg-white dark:bg-slate-900 border text-center border-slate-200 dark:border-slate-700/60 rounded-lg overflow-hidden shadow-sm">
                          <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left text-slate-600 dark:text-slate-300">
                              <thead className="text-xs text-slate-500 dark:text-slate-400 uppercase bg-slate-50 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700/60">
                                <tr>
                                  <th scope="col" className="px-3 py-2 font-semibold w-12 text-center">No</th>
                                  <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 align-middle">Kode</th>
                                  <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 align-middle">Barang</th>
                                  <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 text-right align-middle">Berat</th>
                                  <th scope="col" className="px-3 py-2 font-semibold border-l border-slate-200 dark:border-slate-700/60 text-center w-20">Aksi</th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                                {selectedItems?.length === 0 ? (
                                  <tr>
                                    <td colSpan="5" className="px-3 py-6 text-center text-slate-400 dark:text-slate-500">Belum ada barang dipilih</td>
                                  </tr>
                                ) : (
                                  selectedItems?.map((bt, i) => (
                                    <tr key={i} className="hover:bg-red-50/50 dark:hover:bg-red-900/10 transition-colors bg-white dark:bg-slate-900">
                                      <td className="px-3 py-1.5 text-center text-slate-400 dark:text-slate-500">{i + 1}</td>
                                      <td className="px-3 py-1.5 font-medium border-l border-slate-200 dark:border-slate-700/60 align-middle text-slate-700 dark:text-slate-300">{bt?.kode_item}</td>
                                      <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-slate-600 dark:text-slate-400 truncate max-w-[150px]">{bt?.jenis_kategori?.nama_jenis}</td>
                                      <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-right tabular-nums text-slate-700 dark:text-slate-300">{bt?.berat} gr</td>
                                      <td className="px-3 py-1.5 border-l border-slate-200 dark:border-slate-700/60 align-middle text-center">
                                        <button
                                          type="button"
                                          onClick={() => removeSelectedItem(bt.id)}
                                          className="inline-flex items-center justify-center w-7 h-7 rounded-lg text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 transition-colors"
                                          title="Batal Hapus"
                                        >
                                          <IconX className="w-5 h-5" />
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="mt-6 max-w-xl mx-auto">
                          <label htmlFor="keterangan_step" className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-1.5 ml-1">
                            Alasan Penghapusan (Keterangan)
                          </label>
                          <textarea
                            ref={keteranganRef}
                            id="keterangan_step"
                            rows="3"
                            className="w-full px-4 py-3 rounded-2xl border-2 border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:ring-4 focus:ring-red-500/10 focus:border-red-500 transition-all resize-none text-sm outline-none shadow-sm"
                            placeholder="Contoh: Barang rusak, salah input, atau stok habis..."
                            value={keterangan}
                            onChange={(e) => setKeterangan(e.target.value)}
                          ></textarea>
                          <p className="mt-2 text-xs text-slate-500 dark:text-slate-500 ml-1 italic flex items-center gap-1.5">
                            <span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
                            Keterangan ini wajib diisi untuk dokumentasi sistem.
                          </p>
                        </div>
                      </div>

                      {/* Footer */}
                      <div className="px-5 py-4 border-t border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-900 flex flex-col-reverse sm:flex-row justify-end gap-3 sticky bottom-0 w-full z-10">
                        <button
                          type="button"
                          disabled={loading}
                          onClick={closeModalBanyakBarang}
                          className="w-full sm:w-auto h-11 sm:h-10 px-6 inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 active:bg-slate-300 transition-colors disabled:opacity-50"
                        >
                          Batal
                        </button>
                        <button
                          type="button"
                          disabled={loading || selectedItems?.length === 0 || !keterangan.trim()}
                          onClick={() => setShowConfirm(true)}
                          className="w-full sm:w-auto h-11 sm:h-10 px-8 inline-flex items-center justify-center gap-2 rounded-lg font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 shadow-md shadow-amber-500/20 transition-all disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none disabled:cursor-not-allowed"
                        >
                          <IconTrash className="w-5 h-5" />
                          <span>Lanjut Hapus</span>
                        </button>
                      </div>
                    </>
                  ) : (
                    /* Step 2: Confirmation & Remarks */
                    <div className="p-6 text-center bg-white dark:bg-slate-900">
                      <div className="mb-4 w-14 h-14 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto ring-4 ring-red-50 dark:ring-red-900/10">
                        <IconTrash className="w-7 h-7 text-red-600 dark:text-red-400" />
                      </div>

                      <Dialog.Title as="h2" className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">
                        Konfirmasi Hapus
                      </Dialog.Title>

                      <p className="text-slate-500 dark:text-slate-400 text-sm max-w-sm mx-auto mb-6">
                        Anda yakin ingin menghapus <span className="font-bold text-red-600 dark:text-red-400">{ids?.length} barang</span> yang telah dipilih? Tindakan ini bisa dicek pada menu barang dikeluarkan.
                      </p>

                      <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                        <button
                          type="button"
                          disabled={loading}
                          onClick={() => setShowConfirm(false)}
                          className="flex-1 h-12 inline-flex items-center justify-center rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors disabled:opacity-50"
                        >
                          Batal
                        </button>
                        <button
                          type="button"
                          disabled={loading}
                          onClick={(e) => handleSubmitHapusBanyakBarang(e)}
                          className="flex-[1.5] h-12 inline-flex items-center justify-center gap-2 rounded-xl bg-red-600 text-white font-bold hover:bg-red-700 shadow-lg shadow-red-600/20 active:scale-[0.98] transition-all disabled:opacity-50 disabled:bg-slate-300 disabled:shadow-none"
                        >
                          {loading ? (
                            <div className="w-5 h-5 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
                          ) : (
                            <>
                              <IconTrash className="w-5 h-5" />
                              <span>Ya, Hapus Sekarang</span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  )}

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
